import { render, staticRenderFns } from "./OdporucteBoryGdpr.vue?vue&type=template&id=3ac673ba&scoped=true"
import script from "./OdporucteBoryGdpr.vue?vue&type=script&lang=js"
export * from "./OdporucteBoryGdpr.vue?vue&type=script&lang=js"
import style0 from "./OdporucteBoryGdpr.vue?vue&type=style&index=0&id=3ac673ba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac673ba",
  null
  
)

export default component.exports